import Input from "./input";

const linkInputs = ({ linksData, changeHandler, blurHandler }) => {
  console.log(linksData);
  return (
    <>
      {linksData.map((item, index) => {
        return (
          <div key={index} style={{ display: "flex", gap: "20px" }}>
            <Input
              id="name"
              label="name"
              control="input"
              onChange={changeHandler}
              onBlur={blurHandler}
              index={index}
              valid={item.name.isValid}
              touched={item.name.touched}
              value={item.name.value}
              message={item.name.message}
              required={item.name.required}
            />
            <Input
              id="url"
              label="url"
              control="input"
              onChange={changeHandler}
              onBlur={blurHandler}
              index={index}
              valid={item.url.isValid}
              touched={item.url.touched}
              value={item.url.value}
              message={item.url.message}
              required={item.url.required}
            />
          </div>
        );
      })}
    </>
  );
};

export default linkInputs;
